import ReactQueryProvider from './ReactQueryProvider';
import { ApprovalGuideModalProvider } from './ApprovalGuideModalProvider';
import ZustandProvider from './ZustandProvider';

export default function AppProvider({ children }) {
  return (
    <ReactQueryProvider>
      <ZustandProvider>
        <ApprovalGuideModalProvider>{children}</ApprovalGuideModalProvider>
      </ZustandProvider>
    </ReactQueryProvider>
  );
}
